import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate, useLocation } from "react-router-dom";
import SEO from "../../config/Seo";

import Navbar from "../../Components/Navbar";

import icon from "../../Assets/Images/welcome.png";
import AuthButton from "../../Components/Buttons/AuthButton";
import { onboardUser } from "../../store/reducers/onboardingSlice";

const Welcome = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);

  useEffect(() => {
    const message = queryParams.get("message");

    if (message) {
      // toast.error(message);
    }
    return () => {
      if (message) {
        navigate("/");
      }
    };
  }, []);
  const { userSignedup: user } = useSelector((state) => state.onboarding);

  return (
    <>
      <SEO
        title={"Login | Access Your Ethical Finance Investments | Halvest"}
        description={
          "Log in to your Halvest account and explore ethical finance and Islamic banking solutions."
        }
        name={"Halvest"}
        type={"article"}
      />
      <div className="flex flex-col  min-h-screen">
        <Navbar type={2} />
        <div className="flex flex-col flex-1 justify-between">
          <div className="mx-auto mt-[2.5%] mb-[3%] flex gap-3 ">
            <div
              onClick={() => {}}
              className="w-[68px] h-[9px]   bg-[#6935D3] rounded-[30px] "
            ></div>
            <div
              onClick={() => {}}
              className="w-[68px] h-[9px]   bg-[#6935D3] rounded-[30px] "
            ></div>
            <div className="w-[68px] h-[9px]   bg-[#6935D3] rounded-[30px] "></div>
          </div>
          <div className="w-full flex justify-center gap-10">
            <div className="px-6  py-6  flex flex-col items-center flex-1">
              <img src={icon} className="w-[186px] mb-10 h-[186px]" />
              <h2 className="font-[500] lg:leading-[92.4px]  text-center tracking-[-3.1%] text-[#131E3D] text-[36px] lg:text-[84px]">
                Welcome to Halvest,
              </h2>
              <h2 className="font-[500] lg:leading-[92.4px] capitalize text-center tracking-[-3.1%] text-[#9C9C9E] text-[36px] lg:text-[84px]">
                {user?.name?.split(" ")[0]}
              </h2>
              <h4 className="font-[500]  mt-5 text-[16px] text-center md:w-[600px] text-[#9C9C9E] leading-[16.8px]">
                Your account has been created successfully
              </h4>
              <AuthButton
                title={"Show me around"}
                onClick={() => {
                  dispatch(onboardUser());
                  navigate("/", { replace: true });
                }}
                mainClasses={" w-full !md:w-[182px] "}
                // textStyles={"group-hover:text-[#192851]"}
              />
            </div>
          </div>
          <h4 className="font-[400]  self-end justify-self-end mx-auto max-w-[90%] my-8 text-sm text-[#9C9C9E] tracking-[-0.4%]">
            The information on this website is provided for informational
            purposes only and does not constitute investment advice. You should
            not make any investment decisions based solely on the information on
            this website. You should consult with a qualified financial advisor
            before making any investment decisions. This website may contain
            links to third-party websites. These links are provided for your
            convenience only and do not constitute an endorsement by Halvest of
            the content on such websites. Halvest is not responsible for the
            content of any linked website. This website and these terms of use
            shall be governed by and construed in accordance with the laws of
            [Your Jurisdiction], without regard to its conflict of laws
            provisions.
          </h4>
        </div>
      </div>
    </>
  );
};

export default Welcome;
